var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShineIcon = function SvgShineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 91 61"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.824,
    d: "M2 3.36c.965 1.93 1.884 3.876 2.843 5.81a43 43 0 0 1 1.607 3.585c.037.097.223.936.223.618M37.824 11.816c.313-.418.339-.898.482-1.385.4-1.362 1.188-2.703 1.866-3.943.54-.985 1.862-3.564 2.77-4.017M63.857 29.616c.63-1.531 2.322-2.87 3.46-3.98 2.244-2.185 4.63-4.234 7.01-6.267.634-.543 1.388-.971 1.99-1.546.11-.104.223-.481.223-.222M79.433 58.765c3.024-1.21 6.445-1.333 9.568-2.225"
  })));
};
export default SvgShineIcon;